import destinationPath from '~/utils/destinationPath';

import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SearchPlacement = 'search_box' | 'view_more';

export type SearchTargetProperties = {
  destination_path?: string;
  placement: SearchPlacement;
  search_term: string;
};

type EventData = {
  destinationPath?: string;
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  placement: SearchPlacement;
  searchTerm: string;
};

class SearchInteractionEvent extends InteractionEvent<
  EventData,
  SearchTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'search';
  }

  protected get keepalive(): boolean {
    return true;
  }

  protected getTargetProperties(): SearchTargetProperties {
    return {
      destination_path: this.data.destinationPath
        ? destinationPath(this.data.destinationPath)
        : undefined,
      placement: this.data.placement,
      search_term: this.data.searchTerm
    };
  }
}

export default SearchInteractionEvent;
